export const RETENTION_ERROR = {
    EXISTED: "validation.retentionObj.existed",
    INVALID: "validation.retentionObj.retention.invalid"
}